const locale = localStorage.getItem('locale');

if (!locale) {
  localStorage.setItem('locale', 'en');
}

module.exports = locale || 'en';
